import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { expenseCategoriesQueryOptions, taxRatesQueryOptions } from '../../../../features/finance/queries'
import { NewRecurringPage } from '../../../../features/finance/recurring-pages'
import { newRecurringSearchSchema } from '../../../../features/finance/search'

export const Route = createFileRoute('/_app/expenses/recurring/new')({
  staticData: { crumb: 'recurringNew' },
  validateSearch: newRecurringSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'expenses.create'),
  loader: ({ context }) => {
    // The form opens with the default tax rate: have the rates (and categories) ready.
    void context.queryClient.prefetchQuery(expenseCategoriesQueryOptions)
    return context.queryClient.ensureQueryData(taxRatesQueryOptions).catch(() => undefined)
  },
  component: NewRecurringPage,
})
